import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function approvalrequestReducer(state = initialState.approvalrequest || [], action: any) {
  switch (action.type) {
    case types.SAVE_APPROVALREQUEST_SUCCESS:
      return action.approvalrequest;
    default:
      return state;
  }
}

